import {formattedPropertyModel, intlShape, utils} from '@wallaby-ui/core';
import {isNil, isString} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import styles from './DecimalWithIconFormatter.less';

class DecimalWithIconFormatter extends React.PureComponent {
  render() {
    const {intl, value} = this.props;
    let parsedValue;
    if (!isNil(value)) {
      if (value.value) {
        parsedValue = JSON.parse(value.value);
      } else if (isString(value)) {
        parsedValue = JSON.parse(value);
      }
    }
    if (!isNil(parsedValue)) {
      if (parsedValue.value) {
        const propDefinition = new formattedPropertyModel.FormattedProperty({
          type: formattedPropertyModel.FORMATTED_PROPERTY_TYPE_DECIMAL,
        });
        const formattedValue = !isNil(parsedValue.value)
          ? formattedPropertyModel.FormattedProperty.formatValue(
              propDefinition,
              parsedValue.value,
              intl
            )
          : '';
        const label = parsedValue.tooltip
          ? utils.TranslateUtils.translate(parsedValue.tooltip, intl)
          : undefined;

        return (
          <div
            className={styles.dlDecimalWithIconFormatter}
            title={formattedValue}
          >
            <span className={styles.dlDecimalWithIconValue}>
              {formattedValue}
            </span>
            {parsedValue.icon && (
              <i
                title={label}
                className={parsedValue.icon}
                style={{
                  color: parsedValue.color ? parsedValue.color : '#dedede',
                }}
              />
            )}
          </div>
        );
      }
    }
    return '';
  }
}

DecimalWithIconFormatter.displayName = 'DecimalWithIconFormatter';

DecimalWithIconFormatter.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.any),
    PropTypes.string,
  ]),
};

DecimalWithIconFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(DecimalWithIconFormatter);
